/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RootTree } from './RootTree/v2';
import { useCameraGroups } from './RootTree/use-camera-groups';
import { AdvanceSearch } from './AdvanceSearch';

import './styles.scss';
import { WithLatestStateDeviceNode } from './RootTree';
import { useDispatch, useSelector } from 'react-redux';
import { updateRecoveryLivePage } from '../../../redux/recovery/action';
import { getRecoveryLivePage } from '../../../redux/recovery/reducer';

export const normalizeIds = (ids) => {
  return [...new Set(ids)].sort();
};

export const mapToIds = (map) => {
  return Object.keys(map || {})
    .filter((id) => map[id])
    .sort();
};

export const isEqualArray = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  return a.every((val, i) => val === b[i]);
};

export const LiveTree = ({
  namespace,
  onSelect: _onSelect,
  selectedGroup,
  onSelectCamera,
  selectedCamera,
  getIsCameraPinned,
  onPinCamera,
  setAsCustomCamera,
  customCamera,
}) => {
  const selectedId = selectedGroup?.id;
  const { rootGroups, getChildren, getCameras, groupMap, getPath } =
    useCameraGroups({
      namespace,
    });

  const [expandedMap, setExpandedMap] = useState({});

  const getIsExpanded = (groupId) => expandedMap[groupId] ?? false;
  const dispatch = useDispatch();
  const { expandedTreeGroupIds } = useSelector(getRecoveryLivePage);

  const onExpand = useCallback(
    (groupId) => {
      setExpandedMap((prev) => {
        const tmp = { ...prev, [groupId]: !prev[groupId] };
        const nextIds = normalizeIds(mapToIds(tmp));
        if (!isEqualArray(nextIds, normalizeIds(expandedTreeGroupIds))) {
          dispatch(
            updateRecoveryLivePage({
              expandedTreeGroupIds: nextIds,
            }),
          );
        }
        return tmp;
      });
    },
    [dispatch, expandedTreeGroupIds],
  );

  useEffect(() => {
    const normalized = normalizeIds(expandedTreeGroupIds);

    const newMap = normalized.reduce((acc, id) => {
      acc[id] = true;
      return acc;
    }, {});

    const currentIds = normalizeIds(mapToIds(expandedMap));

    if (!isEqualArray(normalized, currentIds)) {
      setExpandedMap(newMap);
    }
  }, [expandedTreeGroupIds, expandedMap]);

  const [isolatedPath, setIsolatedPath] = useState([]);
  const [groupIdToScrollTo, setGroupIdToScrollTo] = useState(null);

  const onSelect = useCallback(
    (group) => {
      // if (group.id === ROOT_GROUP_ID) {
      //   setSelectedGroupFromSearch(null);

      //   return;
      // }
      _onSelect(group);
      // // retain the search result if not clicked the root group
      // setSelectedGroupFromSearch((prev) => {
      //   if (!prev) {
      //     return prev;
      //   }

      //   if (prev.id === group.id || prev.parentPath.includes(group.id)) {
      //     // If selecting a group under that path
      //     const index = prev.parentPath.findIndex((id) => id === group.id);
      //     const newParentPath = prev.parentPath.slice(0, index + 1);

      //     return {
      //       ...group,
      //       parentPath: newParentPath,
      //     };
      //   }

      //   return prev;
      // });
    },
    [_onSelect],
  );

  const getShouldScrollAfterLoad = useCallback(
    (groupId) => {
      return groupIdToScrollTo === groupId;
    },
    [groupIdToScrollTo],
  );

  const [searchGroup, setSearchGroup] = useState(null);

  const isSearchMode = !!searchGroup || !!customCamera;

  const onSelectAdvanceSearchGroup = (group) => {
    setSearchGroup(group);

    const additionalExpand = group.parentPath.reduce((acc, id) => {
      acc[id] = true;

      return acc;
    }, {});

    setExpandedMap((prev) => ({ ...prev, ...additionalExpand }));
    _onSelect(group);
    // setIsolatedPath(group.parentPath);
    // setGroupIdToScrollTo(group.id);
  };

  const filterChildren = (child, level) => {
    if (!isolatedPath.length) {
      return true;
    }

    const index = level;

    if (index >= isolatedPath.length) {
      return true;
    }

    return isolatedPath[index] === child.id;
  };

  const showCollapseAll = useMemo(() => {
    return Object.values(expandedMap).some((expanded) => expanded);
  }, [expandedMap]);

  const onCollapseAll = () => {
    if (typeof selectedId !== 'number') {
      setExpandedMap({});

      return;
    }

    const path = getPath(selectedId);

    setExpandedMap({
      ...path.reduce((acc, id) => {
        acc[id] = true;

        return acc;
      }, {}),
    });

    if (selectedId !== groupIdToScrollTo) {
      setGroupIdToScrollTo(selectedId);
    } else {
      setGroupIdToScrollTo(null);
      setTimeout(() => {
        setGroupIdToScrollTo(selectedId);
      }, 100);
    }
  };

  const showVisibilityToggle = typeof selectedId === 'number' && selectedId > 0;
  const isShowAll = !isolatedPath.length;

  const onShowVisibility = () => {
    if (!isShowAll) {
      setIsolatedPath([]);
      setGroupIdToScrollTo(null);
      setTimeout(() => {
        setGroupIdToScrollTo(selectedId);
      }, 100);
    } else {
      setIsolatedPath(getPath(selectedId));
    }
  };

  return (
    <div className="live-page-tree">
      <AdvanceSearch
        namespace={namespace}
        onSelectCamera={setAsCustomCamera}
        onSelectGroup={onSelectAdvanceSearchGroup}
        getIsCameraPinned={getIsCameraPinned}
        onPinCamera={onPinCamera}
      />
      <div style={{ height: 8 }}></div>
      <div className="live-page-tree-content">
        {/* <Recent
          namespace={namespace}
          isSelected={selectedId === RECENT_GROUP_ID}
          onSelect={() => onSelect({ id: RECENT_GROUP_ID })}
          getCameras={getCameras}
          getChildren={getChildren}
          getIsSelected={(id) => selectedId === id}
          onSelectGroup={(id) => onSelect(getGroup(id))}
          items={recentItems}
          onRemoveCamera={removeCameraFromRecent}
          selectedSerial={selectedCamera?.serial}
          onSelectCamera={(cam) => {
            onSelectCamera(cam);
            onSelect({ id: RECENT_GROUP_ID });
          }}
        /> */}
        {/* <AllCameras
          namespace={namespace}
          isSelected={selectedId === ROOT_GROUP_ID}
          onSelect={() => onSelect({ id: ROOT_GROUP_ID })}
          onSelectCamera={(cam) => {
            onSelectCamera(cam);
            addCameraToRecent(cam);
            onSelect({ id: ROOT_GROUP_ID });
          }}
          selectedSerial={selectedCamera?.serial}
        /> */}
        {isSearchMode && (
          <div className="live-page-tree-back-button">
            <a
              onClick={() => {
                setSearchGroup(null);
                setAsCustomCamera(null);
              }}
              style={{
                color: '#0e9347',
                textDecoration: 'underline',
                display: 'block',
                height: 24,
              }}
            >
              Back
            </a>
          </div>
        )}
        {!!customCamera && (
          <WithLatestStateDeviceNode
            isPinned={getIsCameraPinned(customCamera.serial)}
            onPin={(pinned) => onPinCamera(customCamera, pinned)}
            name={customCamera.name}
            serial={customCamera.serial}
            state={customCamera.state}
            isSelected={selectedCamera?.serial === customCamera.serial}
            onSelect={() => {
              onSelectCamera(customCamera);
            }}
          />
        )}
        {!customCamera && (
          <RootTree
            onSelect={onSelect}
            selectedId={selectedId}
            rootGroups={searchGroup ? [searchGroup] : rootGroups}
            getChildren={getChildren}
            getCameras={getCameras}
            groupMap={groupMap}
            onSelectCamera={(cam, groupId) => {
              onSelectCamera(cam);
              onSelect({ id: groupId, name: groupMap[groupId]?.name });
            }}
            getIsExpanded={getIsExpanded}
            onExpand={onExpand}
            getShouldScrollAfterLoad={getShouldScrollAfterLoad}
            getIsCameraSelected={(serial) => selectedCamera?.serial === serial}
            getIsCameraPinned={getIsCameraPinned}
            onPinCamera={onPinCamera}
            filterChildren={filterChildren}
            showCollapseAll={showCollapseAll}
            onCollapseAll={onCollapseAll}
            showVisibilityToggle={showVisibilityToggle}
            onShowVisibility={onShowVisibility}
            isShowAll={isShowAll}
            className={!!searchGroup ? 'search-mode' : ''}
          />
        )}
      </div>
    </div>
  );
};
